module.exports = __webpack_public_path__ + "img/masterCardCircle.ece89d3e.svg";